import { useCallback, useMemo, useState } from 'react';

import knoopgebiedData from './data/Knoopgebied.json';

const mapDotData = [
  { label: 'Noord Oost', value: 10, top: '26%', left: '72%', maxCapacity: 100 },
  { label: 'Flevoland', value: 37, top: '36%', left: '52%', maxCapacity: 80 },
  { label: 'AMR + NH', value: 60, top: '28%', left: '39%', maxCapacity: 120 },
  { label: 'Asd', value: 54, top: '38%', left: '41%', maxCapacity: 90 },
  { label: 'Hfd', value: 24, top: '42%', left: '34%', maxCapacity: 120 },
  { label: 'Groot Gv', value: 127, top: '50%', left: '28%', maxCapacity: 130 },
  { label: 'Groot Rtd', value: 90, top: '58%', left: '30%', maxCapacity: 140 },
  { label: 'Vs Rsd Bd', value: 127, top: '68%', left: '32%', maxCapacity: 100 },
  { label: 'Zuid', value: 56, top: '70%', left: '60%', maxCapacity: 100 },
  { label: 'Ah Nm', value: 8, top: '55%', left: '65%', maxCapacity: 120 },
  { label: 'Ut Amf Gd', value: 10, top: '48%', left: '50%', maxCapacity: 110 },
  { label: 'Zp Dv', value: 10, top: '45%', left: '66%', maxCapacity: 120 },
  { label: 'Es Hgl Aml', value: 10, top: '44%', left: '82%', maxCapacity: 110 },
];

export default function useBakkenteller(initialLabel: string = 'Ut Amf Gd') {
  const [selectedLabel, setSelectedLabel] = useState<string | null>(initialLabel);

  const knoopGebiedInfo = useMemo(
    () =>
      Object.fromEntries(knoopgebiedData.map((region) => [region.label, { title: region.title, keys: region.keys }])),
    [knoopgebiedData],
  );

  const getDotColor = useCallback((percentage: number): string => {
    if (percentage < 33) return 'var(--tractie-color-content-success)';
    if (percentage < 70) return 'var(--tractie-color-content-warning)';
    return 'var(--tractie-color-content-error)';
  }, []);

  const getCardData = useCallback(
    (label: string | null) => {
      if (label && knoopGebiedInfo[label]) {
        const dot = mapDotData.find((d) => d.label === label);
        const maxCapacity = dot?.maxCapacity ?? 100;
        return {
          title: knoopGebiedInfo[label].title,
          subtitle: 'Knoopgebied',
          list: knoopGebiedInfo[label].keys.map(({ key, value }) => {
            const percentage = (value / maxCapacity) * 100;
            return { key, value, color: getDotColor(percentage) };
          }),
        };
      }
    },
    [knoopGebiedInfo, getDotColor],
  );

  const cardData = useMemo(() => getCardData(selectedLabel), [selectedLabel, getCardData]);

  const handleDotClick = useCallback((label: string) => {
    setSelectedLabel(label);
  }, []);

  return {
    mapDotData,
    selectedLabel,
    setSelectedLabel,
    cardData,
    handleDotClick,
    getDotColor,
  };
}
